module.exports = __webpack_public_path__ + "static/media/3.c4870bb6.png";